<template>
  <div class="container-fluid" style="position: absolute; min-width: 100%; min-height: 100%; max-width: 100%; display: flex; align-items: center;"><!--bg-maintenance-image-->

    <QrCode ref="QrCode" :name="'QrCode'" @onQr="getSerial"/>

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1 pl-0 pr-0">
      <div class="card border-grey border-lighten-3 box-shadow-3 px-0 pl-0">

        <div class="card-header no-border">
            <div class="row card-title text-xs-center">
                <div class="pt-1 pl-1 pr-1">
                  
                  
                  
                  <div class="row col-md-12">
                    <img style="max-height: 3em; width: 3em; object-fit: contain; float: left;" src="../assets/pictures/icon.png">

                    <!-- <div id="avatar" style="height: 3em; width: 3em; float: left;" v-if="guid != null">
                      <div class="image-cropper" style="height: 100%; width: auto; float: right;">
                        <img :src="userPict" alt="avatar" class="profile-pic">
                      </div>
                    </div> -->
                    <img v-if="guid != null" style="height: 3em; width: 3em; float: left; object-fit: contain; border-radius: 50%;"  :src="userPict" alt="avatar">

                    <span v-if="guid != null" style="float: left; max-width: 40%">{{nameUser}}</span>

                    <ul class="nav navbar-nav" style="float: right;">
                      <li class="dropdown dropdown-language nav-item">
                        <a id="dropdown-flag" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn dropdown-toggle nav-link">
                          <i ref="lang_btn" class="flag-icon" :class="$i18n.tc('lang.logo', $i18n.locale )"></i>
                        </a>
                        
                        <div aria-labelledby="dropdown-flag" class="dropdown-menu">
                          <a class="dropdown-item" :id="lang" v-for="(lang, index) in listLanguages" :key="index" @click="changeLanguage(lang)">
                            <i class="flag-icon" :class="$i18n.getLocaleMessage(lang).lang.logo"></i> {{ $i18n.getLocaleMessage(lang).lang.title }}
                          </a>
                        </div>
                      </li>
                    </ul>

                  </div>
                  <div class="row col-md-12 mt-1">
                    <h6 v-if="selectedMount != null">{{selectedMount.name}}</h6>
                    <h6 v-if="selectedPoint != null">{{selectedPoint.name}}</h6>
                  </div>
                </div>
                
            </div>

            <h6 class="card-subtitle line-on-side text-muted text-xs-center font-small-3" style="margin-bottom: 5px"></h6>

            <!-- <div class="row" style="display: flex; align-content: center; justify-content: center;">
              <a v-if="guid != null" class="btn-sm btn-primary" @click="logout()"><i class="icon-exit"></i> {{$t('titles.logout')}}</a>
            </div> -->
        </div>

        <div class="card-body">
          <div class="card-block" v-if="guid == null">
            <div class="row col-md-12" >
              <div class="col-md-6 offset-md-3">
                
                <fieldset class="form-group position-relative has-icon-left" :class="{ 'form-group--error': $v.card_numb.$error }">
                    <input type="text" v-model.trim="$v.card_numb.$model" :placeholder="$t('check.titles.passCard')" class="form-control form-control-lg input-lg" id="card_numb" v-on:keyup.enter="Auth()">
                    <div class="form-control-position">
                        <i class="icon-head"></i>
                    </div>
                    <div class="error" v-if="!$v.card_numb.required">{{$t('errors.required')}}</div>
                </fieldset>
                  
              </div>
              <div class="col-md-6 offset-md-3 mb-1" style="display: flex; align-content: center; justify-content: center;">
                <button type="button" class="btn btn-warning btn-lg btn-block" @click="Auth()">
                  <i style="color: #FFFFFF" class="icon-unlock2"></i> {{ $t('login.lbl.login') }}
                </button>
              </div>
            </div>
          </div>
              
          <div class="card-block" style="padding: 0 1rem 1rem 1rem;" v-if="guid != null">

              <div class="row mb-1"><div class="col-md-12">
                <a v-if="guid != null && selectedMount == null" class="btn-lg btn-warning" @click="prevFunc()"><i class="icon-exit"></i> {{ $t('titles.logout') }}</a>
                <a v-if="guid != null && selectedMount != null" class="btn-lg btn-warning" @click="prevFunc()"><i class="icon-undo2"></i> {{ $t('check.btn.back') }}</a>
              </div></div>

              <div class="row" v-if="selectedMount == null && placesMount.length > 0">
                <div class="col-md-12">

                  <form class="form"><h4 class="form-section"><i class="icon-map4"></i> {{$t('check.titles.chooseMount')}}</h4></form>
                  <div class="list-group">
                    <div class="alert alert-warning hand" style="margin-bottom: 0.3rem;" v-for="(item,index) in placesMount" :key="index" @click="item.checked = true; selectedMount = item; getPointsAudit();">
                      <span style="font-size: 1.2em">{{ item.name }}</span>
                    </div>
                  </div>

                </div>
              </div>

              <div class="row" v-if="selectedPoint == null && cPoints.length > 0">
                <div class="col-md-12">

                  <form class="form"><h4 class="form-section"><i class="icon-list"></i> {{$t('check.titles.choosePoint')}}</h4></form>
                  <div class="list-group">
                    <div class="alert alert-warning hand" style="margin-bottom: 0.3rem;" v-for="item, index in cPoints" :key="index" @click="selectedPoint = item;">
                      <span style="font-size: 1.2em">{{ item.name }}</span>
                    </div>
                  </div>

                </div>
              </div>


              <div class="row mt-1" v-if="selectedPoint != null && selectedMount != null">
                
                <div class="col-md-8" style="margin-top: 5px">
                  <!-- <fieldset class="form-group position-relative has-icon-left" :class="{ 'form-group--error': $v.serial.$error }">
                    <input type="text" v-model.trim="$v.serial.$model" :placeholder="$t('equipm.table.serNumber')" class="form-control form-control-lg input-lg" id="serial" v-on:keyup.enter="$refs.sendSerial.click()">
                    <div class="form-control-position">
                        <a data-toggle="modal" data-target="#modalQR" @click="$store.state.active_qr = true">
                          <i style="font-size: 1.5rem" class="icon-qrcode"></i>
                        </a>
                    </div>
                    <div class="error" v-if="!$v.serial.required">{{$t('errors.required')}}</div>
                  </fieldset> -->

                  <div class="input-group" :class="{ 'form-group--error': $v.serial.$error }">
                    <div class="input-group-prepend">
                      <button type="button" class="btn btn-warning btn-round" @click="showModalQR()"  data-html="true" :title=" $t('equipm.hint.scanQr')">
                          <i style="font-size: 1.5rem" class="icon-qrcode"></i>
                      </button>
                    </div>
                    <input type="text" v-model.trim="$v.serial.$model" :placeholder="$t('equipm.table.serNumber')" class="form-control form-control-lg input-lg" id="serial" v-on:keyup.enter="$refs.sendSerial.click()">
                  </div>
                  
                </div>

                <div class="col-md-4 mb-1" style="margin-top: 5px" v-if="selectedPoint != null && selectedMount != null && questions.length < 1">
                  <button ref="sendSerial" type="button" class="btn btn-lg btn-block btn-warning" @click="gotQuestions()">
                    {{ $t('check.btn.gotInstr') }}
                  </button>
                </div>
              </div>

              <div v-if="isValid(serial) && selectedPoint != null && selectedMount" class="row mt-1 col-md-12" style="display: flex; align-content: center; justify-content: center; margin-bottom: 1em">
                <button type="button" class="btn btn-lg btn-block btn-warning" @click="openURL()">
                  <i class="icon-new-tab"></i> {{$t('tasks.buttons.photo')}}
                </button>
              </div>
          
              <div class="row col-md-12" v-if="questions.length > 0">
                <form class="form">
                  <h4 class="form-section">
                    <i class="icon-file-text2"></i> {{ $t('check.titles.checkList') }} 
                  </h4>
                </form>
                <div class="">
                  <div class="table-responsive">
                      <table class="table table-striped table-hover mb-0" cellspacing="0">
                          <tbody>
                            <tr class="hand alert-warning" v-for="(item,index) in questions" :key="index" >
                                <td @click="item.answer = !item.answer; onChangeAnswers()">
                                  <span style="font-size: 1.4rem">{{ item.question }}</span>
                                </td>
                                <td style="vertical-align: middle;">
                                  <fieldset>
                                    <input type="checkbox" v-model="item.answer" id="remember-me" class="chk-remember" @click="item.answer = !item.answer; onChangeAnswers()">
                                  </fieldset>
                                </td>
                            </tr>
                          </tbody>
                      </table>
                  </div>
                </div>

              </div>

              <div v-if="showBtnSend" class="row mt-1 col-md-12" style="display: flex; align-content: center; justify-content: center; margin-bottom: 1em">
                <button type="button" class="btn btn-lg btn-block btn-warning" @click="sendReport()">
                  <i class="icon-upload3"></i> {{ $t('check.btn.send')}}
                </button>
              </div>



            </div>
        </div>

        </div>
      </div>
    </div>

    </div>         
</template>

<script>
import { required, minLength} from 'vuelidate/lib/validators'

  export default {
      name: "Audit",
      components: {},
      data() {
          return {
            errors: [],
            submitStatus: null,

            guid: null,
            nameUser: null,
            userPict: null,

            authorized: false,
            card_numb: null,

            placesMount: [],
            selectedMount: null,

            cPoints: [],
            selectedPoint: null,

            serial: null,

            questions: [],

            showBtnSend: false,
          };
        },
        validations: {
          card_numb:{ required },
          serial:{ required, minLength: minLength(9) },
        },
        methods: {
          Auth(){
            this.errors = [];
            this.$v.$reset();

            if ( this.isValid(this.card_numb) == false ){ this.errors.push(''); }

            if (this.errors.length < 1){
              
              this.authorized = false;
              let dataRequest = {
                number: this.card_numb
              };
              this.makeQuery("/service/loginByCard", {dataRequest : dataRequest})
              .then(result => {
                localStorage.setItem('cardNumber', this.card_numb);
                if(result.UID != undefined){ 
                  this.guid = result.UID;
                  //localStorage.setItem('guidUsrChecklist', this.guid);
                }
                if(result.Name != undefined){ 
                  this.nameUser = result.Name;
                  //localStorage.setItem('nameUsrChecklist', this.nameUser);
                }
                if(result.faceImage != undefined){
                  this.userPict = "data:image/png;base64," + result.faceImage;
                  //this.userPict = require('../assets/pictures/profile.png');
                }

                this.getPlaceMount();
              
                this.$v.$reset();
                this.authorized = true;
              })
              .catch(result => {this.showNotification('custom-error','Error',result); });
              
            } else {
              this.$v.$touch();
              if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
              }
            }
          },
          logout(){
            this.guid = null;
            localStorage.removeItem('guidUsrChecklist');
            this.nameUser = null;
            
            localStorage.removeItem('nameUsrChecklist');
            this.userPict = null;
            this.card_numb = null;
            localStorage.removeItem('cardNumber');

            this.selectedMount = null;
            this.placesMount = [];

            this.selectedPoint = null;
            this.cPoints = [];

            this.serial = null;
            
            this.questions = [];

            this.$v.$reset();
          },
          getPlaceMount(){
            
            this.selectedMount = null;
            this.placesMount = [];

              
            let dataRequest = {};
            this.makeQuery("/service/getPlace", {dataRequest : dataRequest})
            .then(result => {
            
              if(result.length > 0){
                let arr = [];
                for (let i = 0; i < result.length; i++) {
                  arr.push({
                    name: result[i].name,
                    uid: result[i].wp_id,
                    checked: false
                  });

                  this.placesMount = arr;                  
                }
              }
            })
            .catch(result => {this.showNotification('custom-error','Error',result); });
            /*
           this.placesMount = [
              {name: 'місце зборки 1', uid: 13213},
              {name: 'місце зборки 2', uid: 13214},
              {name: 'місце зборки 3', uid: 13215}
            ];*/
          },
          getPointsAudit(){
            if (this.selectedMount.uid != undefined){
              this.selectedPoint = null;
              this.cPoints = [];
              
              
              let dataRequest = {
                place: this.selectedMount.uid
              };
              this.makeQuery("/service/getPointAudit", {dataRequest : dataRequest})
              .then(result => {
              
                if(result.length > 0){
                  let arr = [];
                  for (let i = 0; i < result.length; i++) {
                    arr.push({
                      name: result[i].name,
                      uid: result[i].UID,
                      order: result[i].order,
                      checked: false
                    });
                    arr.sort(function(obj1, obj2) { return obj2.order-obj1.order;});
                    this.cPoints = arr;                  
                  }
                }
                this.$v.$reset();

              })
              .catch(result => {this.showNotification('custom-error','Error',result); });
              /*
              this.cPoints = [
                {name: 'Монтаж', uid: 1245},
                {name: 'Сборка', uid: 12452},
                {name: 'Перевірка', uid: 12454},
                {name: 'Ще щось...', uid: 12451},
              ];*/
            }
          },
          getSerial(serial) {
            if ( this.isValid(serial) ){
              this.serial = serial;
              this.gotQuestions();
            }
          },
          gotQuestions(){
            this.errors = [];
            this.$v.$reset();

            if ( this.isValid(this.serial) == false ){ this.errors.push(''); }
            if ( this.selectedMount == null ){ this.errors.push(''); }
            if ( this.selectedPoint.uid == null ){ this.errors.push(''); }

            if (this.errors.length < 1){
              
              let str = this.serial.toLowerCase();
              if(str.indexOf('se-') < 0){
                str = 'ме-' + str.split('-')[1];
              }

              let serial = JSON.parse( JSON.stringify(str) );
              this.serial = serial;
              

              this.questions = [];
              let dataRequest = {
                place: this.selectedMount.uid,
                SerialNumb: serial,
                UID: this.selectedPoint.uid
              };

              this.makeQuery("/service/getCheckListAudit", {dataRequest : dataRequest})
              .then(result => {

                if(result.length > 0){
                  for (let i = 0; i < result.length; i++) {
                    this.questions.push({question: result[i].name,
                                          answer: result[i].result,
                                          name: result[i].userName,
                                          uid: result[i].QID});
                  }
                  
                } else {
                  this.showNotification('custom-info','No data','', -1);
                }

              })
              .catch(result => {this.showNotification('custom-error','Error',result); });
                
                
              
            } else {
              this.$v.$touch();
              if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
              }
            }
          },
          prevFunc(){
            if(this.questions.length > 0){
              this.questions = [];
              this.showBtnSend = false;
            } else
            if((this.selectedMount != null) && (this.selectedPoint != null)){
              this.serial = null;
              this.selectedPoint = null;
              this.getPointsAudit();
            } else
            if(this.cPoints.length > 0){
              this.selectedPoint = null;
              this.cPoints = [];
              this.selectedMount = null;
              this.getPlaceMount();
            } else
            if(this.placesMount.length > 0){
              //очистка всього
              this.logout();
            }
          },
          onChangeAnswers(){
            let checks = 0;
            for (let i = 0; i < this.questions.length; i++) {
              if(this.questions[i].answer == true){ checks++; }
            }

            if(checks == this.questions.length){
              this.showBtnSend = true;
            } else {this.showBtnSend = false;}
          },
          sendReport(){
            let dataRequest = {
              UserID: this.guid,
              SerialNumb: this.serial,
              PointID: this.selectedPoint.uid,
              Value: 1
            };
            this.makeQuery("/service/addCheckList", {dataRequest : dataRequest})
            .then(result => {
              this.showNotification('custom-success',this.serial,'Відправлено', -1);

              this.questions = [];
              this.serial = null;
              this.selectedPoint = null;

              this.cPoints = [];
              this.selectedMount = null;
              this.getPlaceMount();

            })
            .catch(result => {this.showNotification('custom-error','Error',result); });
          },
          openURL(){
            window.open('https://draw.modern-expo.info/qua/' + this.serial);
          }
        },
        computed:{
          listLanguages(){
            let arrLang = [];
            for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
              arrLang[this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id] = this.$i18n.availableLocales[i];
            }
            return arrLang;
          },
        },
        components: {},
        mounted () {},
        watch:{
          serial: function(newVal, oldVal){

          },
          
        },
        created(){
          
          if(localStorage.getItem('cardNumber') != null){
            this.card_numb = localStorage.getItem('cardNumber');
            this.Auth();
          }
          /*
          this.guid = result.UID;
          localStorage.setItem('guidUsrChecklist', this.guid);
          
          this.nameUser = result.Name;
          localStorage.setItem('nameUsrChecklist', this.nameUser);
          */
        }
    }
</script>

<style>
.image-cropper {
    width: 100px;
    height: 100px;
    position: relative;
    overflow: hidden;
    border-radius: 50%;
}
.profile-pic {
  margin: 0 auto;
  height: 100%;
  width: auto;
}
input[type=checkbox]
{
  /* Double-sized Checkboxes */
  -ms-transform: scale(2); /* IE */
  -moz-transform: scale(2); /* FF */
  -webkit-transform: scale(2); /* Safari and Chrome */
  -o-transform: scale(2); /* Opera */
  transform: scale(2);
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/CheckList.vue